//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "contact",
  data() {
    return {
      idx: 6,
      tab_idx: 0,
      yan_code: "",
      content: "",
      name: "",
      phone: "",
      input_code: "",
      codede: "",
      token: "",
      about_tab: [
        {
          text: "联系我们",
          status: 0,
        },
        {
          text: "在线留言",
          status: 1,
        },
      ],
      banner: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated() {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    //初始化地图
    //创建和初始化地图函数：
    function initMap() {
      createMap(); //创建地图
      setMapEvent(); //设置地图事件
      addMapControl(); //向地图添加控件
      addMarker(); //向地图中添加marker
    }

    //创建地图函数：
    function createMap() {
      var map = new BMap.Map("dituContent"); //在百度地图容器中创建一个地图
      var point = new BMap.Point(104.014866, 30.631835); //定义一个中心点坐标
      map.centerAndZoom(point, 13); //设定地图的中心点和坐标并将地图显示在地图容器中
      window.map = map; //将map变量存储在全局
    }

    //地图事件设置函数：
    function setMapEvent() {
      map.enableDragging(); //可拖拽
    }

    //地图控件添加函数：
    function addMapControl() {
      //向地图中添加缩放控件
      var ctrl_nav = new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
        type: BMAP_NAVIGATION_CONTROL_LARGE,
      });
      map.addControl(ctrl_nav);
      //向地图中添加缩略图控件
      var ctrl_ove = new BMap.OverviewMapControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        isOpen: 1,
      });
      map.addControl(ctrl_ove);
      //向地图中添加比例尺控件
      var ctrl_sca = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT });
      map.addControl(ctrl_sca);
    }

    //标注点数组
    var markerArr = [
      {
        title: "中启建设有限公司",
        content: "成都市武侯区星狮路818号4幢4单元503号",
        point: "104.015486|30.630592",
        isOpen: 0,
        icon: { w: 23, h: 25, l: 0, t: 21, x: 9, lb: 12 },
      },
    ];
    //创建marker
    function addMarker() {
      for (var i = 0; i < markerArr.length; i++) {
        var json = markerArr[i];
        var p0 = json.point.split("|")[0];
        var p1 = json.point.split("|")[1];
        var point = new BMap.Point(p0, p1);
        var iconImg = createIcon(json.icon);
        var marker = new BMap.Marker(point, { icon: iconImg });
        var iw = createInfoWindow(i);
        var label = new BMap.Label(json.title, {
          offset: new BMap.Size(json.icon.lb - json.icon.x + 10, -20),
        });
        marker.setLabel(label);
        map.addOverlay(marker);
        label.setStyle({
          borderColor: "#808080",
          color: "#333",
          cursor: "pointer",
        });

        (function () {
          var index = i;
          var _iw = createInfoWindow(i);
          var _marker = marker;
          _marker.addEventListener("click", function () {
            this.openInfoWindow(_iw);
          });
          _iw.addEventListener("open", function () {
            _marker.getLabel().hide();
          });
          _iw.addEventListener("close", function () {
            _marker.getLabel().show();
          });
          label.addEventListener("click", function () {
            _marker.openInfoWindow(_iw);
          });
          if (!!json.isOpen) {
            label.hide();
            _marker.openInfoWindow(_iw);
          }
        })();
      }
    }
    //创建InfoWindow
    function createInfoWindow(i) {
      var json = markerArr[i];
      var iw = new BMap.InfoWindow(
        "<b class='iw_poi_title' title='" +
          json.title +
          "'>" +
          json.title +
          "</b><div class='iw_poi_content'>" +
          json.content +
          "</div>"
      );
      return iw;
    }
    //创建一个Icon
    function createIcon(json) {
      var icon = new BMap.Icon(
        " http://api.map.baidu.com/lbsapi/creatmap/images/us_mk_icon.png",
        new BMap.Size(json.w, json.h),
        {
          imageOffset: new BMap.Size(-json.l, -json.t),
          infoWindowOffset: new BMap.Size(json.lb + 5, 1),
          offset: new BMap.Size(json.x, json.h),
        }
      );
      return icon;
    }

    initMap(); //创建和初始化地图
  },
  mounted() {
    const _this = this;
    _this.get_banner();
    _this.code();
  },
  methods: {
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //获取banner和验证码
    code() {
      const _this = this;
      let Base64 = require("js-base64").Base64;
      _this.$get("header/Security/imageCodeBase64").then((res) => {
        _this.yan_code = "data:image/png;base64," + res.data.base64;
        _this.token = res.data.token;
        _this.codede = res.data.verifyCode;
      });
    },
    get_banner() {
      const _this = this;
      let Base64 = require("js-base64").Base64;
      _this.$get("/header/banner/fetchOne/CONNECTION").then((res) => {
        console.log(res);
        _this.banner = res.data;
      });
    },
    //提交
    submit() {
      const _this = this;
      var mobile_mode = /^1[3456789]\d{9}$/;
      var name = _this.name;
      var phone = _this.phone;
      var input_code = _this.input_code;
      var content = _this.content;
      var data = {
        content: content,
        name: name,
        userTel: phone,
        validateCode: input_code,
        validateToken: _this.token,
      };
      if (name == "") {
        _this.$toast.center("姓名不能为空");
        return false;
      }
      if (!mobile_mode.test(phone)) {
        _this.$toast.center("手机号码有误");
        return false;
      }
      if (content == "") {
        _this.$toast.center("留言内容不能为空");
        return false;
      }
      _this.$post("/header/message/save", data).then((res) => {
        if (res.status == 0) {
          alert("您的留言提交成功，我们将在最快的时间内联系您，请您耐心等待！");
        } else {
          _this.$toast.center(res.msg);
        }
      });
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.tab_idx = a;
      if (a == 0) {
        var a = (document.getElementById("lianxi1").style.display = "none");
        var b = (document.getElementById("map1").style.display = "block");
      } else {
        var a = (document.getElementById("lianxi1").style.display = "block");
        var b = (document.getElementById("map1").style.display = "none");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/contact.vue